import { t } from "i18next"
import { OutTemplateListIcon, InDataListIcon, ConverterListIcon, ProjectIcon, PeoplesIcon, TenantIcon } from '@client/config'
import { ViewGroupProps, ViewProps } from '@client/utils/types'
import SidebarProjectList from "../views/projects/SidebarProjects"
import SidebarOutTemplates from "../views/projects/out/SidebarOutTemplates"
import SidebarInData from "../views/projects/in/SidebarInData"
import SidebarConverters from '../views/converter/SidebarConverters'
import SidebarUsers from "../views/users/SidebarUsers"
import SidebarTenants from "../views/tenants/SidebarTenants"
import { Capabilities } from "@/shared"

//console.log('views: ', t('Templates'))

export function Views(): ViewGroupProps[] {
  return [
    // {
    //   views: [
    //     {
    //       key: 'dashboard',
    //       icon: < DashboardIcon />,
    //       label: t('Dashboard'),
    //       sidebarContent: <Dashboard />,
    //       view: <Dashboard />,
    //       capability: Capabilities.dashboard_read
    //     },
    //   ],
    // },
    {
      views: [
        {
          key: 'template-list',
          icon: <OutTemplateListIcon />,
          label: t('Templates'),
          sidebarContent: <SidebarOutTemplates />,
          capability: Capabilities.template_read
        },
        {
          key: 'data-list',
          icon: <InDataListIcon />,
          label: t('Data lists'),
          sidebarContent: <SidebarInData />,
          capability: Capabilities.data_list_read
        },
        {
          key: 'converters',
          icon: <ConverterListIcon />,
          label: t('Converters'),
          sidebarContent: <SidebarConverters />,
          capability: Capabilities.convert_read
        },
      ],
    },
    {
      views: [
        {
          key: 'projects',
          icon: <ProjectIcon />,
          label: t('Projects'),
          sidebarContent: <SidebarProjectList />,
          capability: Capabilities.project_read
        },
        {
          key: 'users',
          icon: <PeoplesIcon />,
          label: t('Users'),
          sidebarContent: <SidebarUsers />,
          capability: Capabilities.user_read
        },
      ],
    },
    {
      views: [
        {
          key: 'tenants',
          icon: <TenantIcon />,
          label: t('Tenants'),
          sidebarContent: <SidebarTenants />,
          capability: Capabilities.tenant_read
        },
      ],
    },
  ]
}

export function findMenu(menuKey: string) {
  const groups = Views()
  for (let i = 0; i < groups.length; i++) {
    const views = groups[i].views
    const result = views.find((item: ViewProps) => item.key === menuKey)
    if (result) return result
  }

  return null
}
